module.exports = __webpack_public_path__ + "media/npc_dota_hero_doom_bringer.12628887.webm";